import HttpRequest from './core/http_request';

class AgraProvider extends HttpRequest {
  // heavyMetal survey
  saveEnvHeavyMetalSurvey (data) {
    return this.request('post', '/private/survey/agra/surveyEnvHeavyMetal', data);
  }

  getEnvHeavyMetalSurveyList (data) {
    return this.request('get', '/private/survey/agra/surveyEnvHeavyMetal/list', data);
  }

  getEnvHeavyMetalSurveyByRefId (data) {
    return this.request('get', '/private/survey/agra/surveyEnvHeavyMetal/' + data.refId);
  }

  updateEnvHeavyMetalSurvey (data) {
    const refId = data.refId;
    delete data.refId;
    return this.request('post', '/private/survey/agra/surveyEnvHeavyMetal/' + refId, data);
  }

  deleteEnvHeavyMetalSurvey (data) {
    const _id = data._id;
    delete data._id;
    return this.request('post', '/private/survey/agra/surveyEnvHeavyMetal/delete/' + _id, data);
  }

  getEnvHeavyMetalSurveyMyList (data) {
    return this.request('get', '/private/survey/agra/surveyEnvHeavyMetal/myList', data);
  }

  getEnvHeavyMetalSurveyListMap (data) {
    return this.request('get', '/private/survey/agra/surveyEnvHeavyMetal/map', data);
  }

  updateStatusEnvHeavyMetalSurvey (data) {
    const _id = data._id;
    delete data._id;
    return this.request('post', '/private/survey/agra/surveyEnvHeavyMetal/researcher/status/' + _id, data);
  }

  cancelStatusEnvHeavyMetalSurvey (data) {
    const _id = data._id;
    delete data._id;
    return this.request('post', '/private/survey/agra/surveyEnvHeavyMetal/researcher/cancel/' + _id, data);
  }

  updateResultLabEnvHeavyMetalSurvey (data) {
    return this.request('post', '/private/survey/agra/surveyEnvHeavyMetal/researcher/lab', data);
  }

  updateReceiptEnvHeavyMetalSurvey (data) {
    const _id = data._id;
    delete data._id;
    return this.request('post', '/private/survey/agra/surveyEnvHeavyMetal/receipt/' + _id, data);
  }
  // end heavyMetal survey
}

export default AgraProvider;
